import { useUnleashConfig } from '@ucc/admin-unleash-config'
import { IConfig } from 'unleash-proxy-client'

export const useWrapperUnleashConfig = (): IConfig => {
  const unleashConfig = useUnleashConfig()
  return {
    ...unleashConfig,
    bootstrap: [
      {
        enabled: true,
        impressionData: false,
        name: 'tablet.access',
        variant: { enabled: false, name: 'disabled', payload: undefined },
      },
    ],
  }
}
